<template>        
    <b-overlay :show="showoverlay" rounded="sm">            
        <b-form @submit.stop.prevent="onSubmit">
            <div class="clearfix">
                <div class="col-md-12">
                    <div class="row clearfix">
                        <div class="col-md-10"> </div>
                        <div class="col-md-2">
                            
                            <span v-if="fdata.status==1" class="px-3 py-1 rounded ml-2" style="background: rgb(0, 193, 119); color: rgb(255, 255, 255);">Approved</span>
                            <span v-else class="px-3 py-1 rounded ml-2" style="background: rgb(232, 184, 15); color: rgb(255, 255, 255);">Draft</span>
                        
                        </div>
                        <div class="col-md-4">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Financial Year</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-2">{{ fdata.fiscal_year }}</dd>
                            </dl>
                        </div>

                        <div class="col-md-4">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Month</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-2">{{ formatMonthYear(fdata.month,fdata.year) }}</dd>
                            </dl>
                        </div>

                        <div class="col-md-4">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Run Date</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-2">{{fdata.run_date}}</dd>
                            </dl>
                        </div>

                        <div class="col-md-4">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Type of Run</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-2">{{getRunTypeLabel(fdata.run_type)}}</dd>
                            </dl>
                        </div>

                        <div class="col-md-8"> </div>

                        <div class="col-md-8">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Contribution Process</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-2">{{getPolicyTypeLabel(fdata.policy_type)}}</dd>
                            </dl>
                        </div>

                        <div class="col-md-4">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Contribution Amount</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-2">{{formatMoney(fdata.amount)}}</dd>
                            </dl>
                        </div>

                        <div class="col-md-8">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Details and Description</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-4">{{fdata.details}}</dd>
                            </dl>
                        </div>

                        <div class="col-md-4">                                        
                            <dl class="row clearfix mt-3 company-form-container no-border no-shadow">
                                <dt class="col-md-12 pl-0 pr-0">Attachments</dt>
                                <dd class="col-md-12 pl-0 pr-0 mb-4"><a href="#">Download</a></dd>
                            </dl>
                        </div>
                    </div>
                </div>                        
                                                                        
              
                <div class="row clearfix mt-5" v-if="fdata.status == 1">
                    <!-- <div class="col-md-4">
                        <b-button type="submit" class="btn-primary" variant="success"> Download Bank File </b-button>       
                    </div> -->
                    <!-- <div class="col-md-4">
                        <b-button type="submit" class="btn-primary" variant="success"> Send to Bank </b-button>       
                    </div> -->
                     <div class="col-md-4">
                        <!-- <b-button type="submit" class="btn-primary" variant="success"> Unapprove </b-button>        -->
                        <b-button type="submit" class="btn-primary" variant="success"> Unapprove </b-button>       
                    </div>
                </div>

                <div class="row clearfix mt-5" v-else>
                    <div class="col-md-4">
                        <b-button type="submit" class="btn-primary" variant="success"> Delete Run </b-button>       
                    </div>
                    <div class="col-md-4">
                        <b-button type="submit" class="btn-primary" variant="success"> Edit Run </b-button>       
                    </div>
                    <div class="col-md-4">
                        <b-button type="submit" class="btn-primary" variant="success"> Approve </b-button>       
                    </div>                    
                </div>
            </div>

        </b-form>
    </b-overlay>
</template>

<script>
    export default {
        mounted() { },
        
        props: ['data', 'type_of_run'],

        data() {
            return {
                showoverlay: false,                              
   
                fdata: { 
                    fiscal_year: '', 
                    month: '', 
                    year: '', 
                    run_date: this.data.run_date, 
                    run_type: this.run_type, 
                    policy_type: this.data.policy_type, 
                    amount: this.data.amount, 
                    details_and_description: this.data.details,
                    status: this.data.status,
                },
               
                accept:".jpg, .png, .gif, .pdf , .doc , .docx",
                attachment: 'Upload File',  
                multiple:true,               
                
            } 
        },
        
        methods: {
            listReturnAttachment:function (data) {},
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            formatMonthYear(month,year) {
                    const monthNames = [
                        'January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ];
                    if(month && year){
                        return `${monthNames[month - 1]}-${year}`;
                    }
                    return '';
            },
            getRunTypeLabel(run_type) {
                const runTypes = {
                    1: 'Regular',
                    2: 'Manual',
                    3: 'One Off'
                };
                return runTypes[run_type] || 'Unknown';
            },
            getPolicyTypeLabel(policy_type) {
                const policyTypes = {
                    1: 'Direct Balance',
                    2: 'Dynamic Proportion',
                    3: 'Actuarial Amount',
                    4: 'Actuarial Rate'
                };
                return policyTypes[policy_type] || 'Unknown';
            },
            getStatusLabel(status) {
                const statuses = {
                    0: 'Draft',
                    1: 'Approved'
                };
                return statuses[status] || 'Unknown';
            },
                        
            onSubmit(e) { },                                          
                       
        },
        created: function () { 
            this.fdata = this.data;
        },
        computed: { }
        
    }
    
</script>